export default __webpack_public_path__ + "static/media/mShoes_1_c1.2e0ad7f0.jpeg";